console.log('aryahere123')
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
     
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
          
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            const selectedString = formData.get('properties[String]');
            const selectedGrip = formData.get('properties[Grip]');

            const stringVariantMapping = {
              "Yonex BG 65 - ₹550": 41611199381567,
              "Yonex BG 65 Titanium - ₹599": 41610761338943,
              "Yonex BG 66 Ultimax - ₹780": 41611199283263,
              "Yonex BG 80 Power - ₹799": 41611199348799, 
              "Hundred JP 70 - ₹500": 41611199250495,
              "Hundred JP 70 Power - ₹600": 41610784997439,
              "Hundred JP 70 Magnite - ₹700": 43008078053439,
              "Hundred JP 65 Magnite - ₹679": 43008078872639,
              "Hundred JP 58 Magnite - ₹700": 43008079527999,
              "Hundred JP 66 Hunter X - ₹700": 43008079822911,
              "Hundred JP 63 Hunter - ₹800": 43008080248895,
              "Hundred JP 70 Hunter - ₹700": 43008080904255,
              "Hundred JP 66 - ₹625": 43008081657919,
              "Yonex Nanogy 95 - ₹700": 41684244627519,
              "Yonex Exbolt 65 - ₹1000": 42851665215551,
              "Li-Ning No. 7 Boost - ₹649": 43241797287999,
              "Li-Ning No. 1 Boost - ₹749": 43241796829247,
              "Li-Ning No. 1 - ₹649": 43241796698175,
              "Li-Ning No. 1 Rebound - ₹590": 43241796927551,
              "Li-Ning No. 7 Rebound - ₹549": 43241797877823,
              "Li-Ning No. 7 - ₹550": 43241797058623,
              "Li-Ning No. 7 Classic - ₹399": 43241797812287,
              "Li-Ning N61 - ₹749": 43241796632639,
              "Li-Ning N58 - ₹749": 43241796468799,
            };
            const gripVariantMapping = {
              "Yonex Super Grap (AC102EX) - ₹130": 41657868222527,
              "Yonex Towel Grip (AC402EX) - ₹160": 41685097250879,
            };
            
        
            const stringVariantId = stringVariantMapping[selectedString];
            const gripVariantId = gripVariantMapping[selectedGrip];
            // if (stringVariantId) {
            //   const extraProductData = {
            //     id: stringVariantId,
            //     quantity: 1,
            //     properties: {
            //       _hidden: 'true'
            //     }
            //   };
        
            //   return fetch('/cart/add.js', {
            //     method: 'POST',
            //     headers: {
            //       'Content-Type': 'application/json',
            //       'X-Requested-With': 'XMLHttpRequest'
            //     },
            //     body: JSON.stringify(extraProductData)
            //   }).then(() => response);
            // }
            // if (gripVariantId) {
            //   const extraProductData = {
            //     id: gripVariantId,
            //     quantity: 1,
            //     properties: {
            //       _hidden: 'true'
            //     }
            //   };
        
            //   return fetch('/cart/add.js', {
            //     method: 'POST',
            //     headers: {
            //       'Content-Type': 'application/json',
            //       'X-Requested-With': 'XMLHttpRequest'
            //     },
            //     body: JSON.stringify(extraProductData)
            //   }).then(() => response);
            // }
        
            // return response;
            // We need to send both if selected
const promises = [];
const items = [];

if (stringVariantId) {
  items.push({
    id: stringVariantId,
    quantity: formData.get('quantity'),
    properties: {
      Badminton: 'String'
    }
  });
}

if (gripVariantId) {
  items.push({
    id: gripVariantId,
    quantity: formData.get('quantity'),
    properties: {
      Badminton: 'Grip'
    }
  });
}

if (items.length > 0) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ items }) // <-- single API call with multiple items
  }).then(() => response);
}

return response; // if nothing to add
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
